<script setup>
import { ref, onMounted } from 'vue';
import preLoader from './components/preLoader.vue';
import HeaderSection from './layout/HeaderSection.vue';
import FooterSection from './layout/FooterSection.vue';

// Define loading state
const loading = ref(true);

onMounted(() => {
  setTimeout(() => {
    loading.value = false;
  }, 3000);
});
</script>

<template>
  <div>
    <!-- Preloader will show if loading is true -->
    <preLoader v-if="loading" />

    <!-- Main content will show if loading is false -->
    <div v-else>
      <HeaderSection />
      <RouterView />
      <FooterSection />
    </div>
  </div>
</template>

<style scoped>
</style>
